import React from 'react'
import {connect} from 'react-redux'
import {Flex, Jibber, SVGButton, TextInput, H3, Hint} from '/app/src/component'
import EmployeeSelector from '/app/src/model/Employee/selector.js'
import EmployeeModel from '/app/src/model/Employee/model.js'
import UserSelector from '/app/src/model/User/selector.js'
import FileManager from '/app/src/lib/FileManager.js'
import style from './style.css'
import {ReactSlim} from '/app/src/lib/SlimCropper'

class ProfilePicture extends Jibber{
    constructor(props){
        super(props);
        this.useState({
            previewImgUrl: '',
            croppingMode: false,
            blob: [],
            displayName: this.props.displayName,
            name: this.props.name,
            imageUrl: this.props.imageUrl,
            imageDeleted: false,
            imageChanged: false,
            nameChanged: false,
            displayNameChanged: false,
        })

        this.slimInit = this.slimInit.bind(this);
        this.slimService = this.slimService.bind(this);
        this._handleChange = this._handleChange.bind(this);
    }


    componentWillReceiveProps(nextProps){
        this.setState({
            displayName: nextProps.displayName,
            name: nextProps.name,
            imageUrl: nextProps.imageUrl,
            changed: false
        })
    }

    _handleFileUpload(event) {
        const reader = new FileReader();
        const file = event.target.files[0]
        reader.onloadend = () => {
            this.setState({
                previewImgUrl: reader.result
            });
            this.setState({croppingMode: true})
        }
        reader.readAsDataURL(file)
    }

    _handleUploadClick() {
        const id = this.props.id;

        if(this.state.nameChanged){
            this.props.dispatch(EmployeeModel.updateName(id, this.state.name));
        }

        if(this.state.displayNameChanged){
            this.props.dispatch(EmployeeModel.updateDisplayName(id, this.state.displayName));
        }


        if(!this.state.imageDeleted){
            if(this.state.imageChanged){
                this.props.dispatch(EmployeeModel.setIsLoading());
                const blob = FileManager.dataURItoBlob(this.state.blob)
                this.props.dispatch(EmployeeModel.uploadProfileImage(blob, id))
            }
        }else{
            this.props.dispatch(EmployeeModel.deleteEmployeesProfileImg(id));
        }

        this.setState({
            nameChanged: false,
            displayNameChanged: false,
            imageDeleted: false,
            imageChanged: false,
        })

    }

    _onCropClick() {
        this.setState({
            previewImgUrl: this.cropper.crop(),
            croppingMode: false
        });
    }
    // called when slim has initialized
    slimInit(data, slim) {
        // slim instance reference
        // current slim data object and slim reference
    }

    // called when upload button is pressed or automatically if push is enabled
    slimService(formdata, progress, success, failure, slim) {
        // slim instance reference
        //const blob = slim.data.input.file;


        // form data to post to server
        // set serviceFormat to "file" to receive an array of files

        // call these methods to handle upload state
    }

    slimDidTransform(data, slim){
        const blobImage = slim.dataBase64.output.image;
        this.setState({
            blob: blobImage,
        })
    }

    _handleChange(event){
        this.setState({[event.target.name]: event.target.value,})

        if(event.target.name === 'name' && this.state.name !== event.target.value){
            this.setState({nameChanged: true});
        }

        if(event.target.name === 'displayName' && this.state.displayName !== event.target.value){
            this.setState({displayNameChanged: true})
        }


    }

    didRemove(){
        this.setState({
            imageDeleted: true
        })
    }


    render() {
        const changed = this.state.imageDeleted || this.state.imageChanged || this.state.nameChanged || this.state.displayNameChanged
        return(
            <Flex h='100%' w='100%' column dataName='ProfilePicture'>
                <Flex column hAlignContent='right' padding='10px'>
                    <SVGButton
                        text='Spara'
                        src='/images/Save.svg'
                        onClick={this._handleUploadClick.bind(this)}
                        border
                        disabled={!changed}
                        color='black'
                        hover='blue'/>
                    <Flex h='10px' fontSize='12px' fontWeight='400' color='darkgrey' mt='2px'>
                        { changed && '*Ändringar är inte sparade'}
                    </Flex>
                </Flex>
                <Flex  w='100%' hAlignContent='center' overflowY='auto'>
                    <Flex w='70%' column hAlignContent='center'>
                        <Flex shrink={1} className={style.ProfileImageWrapper} w='200px' h='200px'>
                            <ReactSlim
                                ratio="1:1"
                                initialImage={this.state.imageUrl}
                                minSize={ { width:200, height:200 } }
                                service={ this.slimService.bind(this) }
                                didInit={ this.slimInit.bind(this) }
                                label={'Ladda upp bild'}
                                push={false}
                                instantEdit={true}
                                didTransform={this.slimDidTransform.bind(this)}
                                didRemove={this.didRemove.bind(this)}
                                didConfirm={() => {this.setState({imageChanged: true, imageDeleted: false})}}
                                >
                                <input type="file" name="foo"/>
                            </ReactSlim>
                        </Flex>
                        <Flex column shrink={0}>
                            <Flex style={{marginBottom: '25px'}} width='400px' column>
                                <H3 marginBottom='5px'> Displaynamn (frivilligt) <Hint position='right' tooltip='Namn som visas utåt mot besökare. Om inget displaynamn anges så visas ditt interna namn.'/></H3>
                                <TextInput maxLength='20' placeholder='Displaynamn'  onChange={this._handleChange} autoComplete='name' value={this.state.displayName} name='displayName'/>
                            </Flex>
                            <Flex style={{marginBottom: '25px'}} column width='400px'>
                                <H3 marginBottom='5px'> Namn (internt) </H3>
                                <TextInput maxLength='20' placeholder='Namn' onChange={this._handleChange} autoComplete='name' value={this.state.name} name='name'/>
                            </Flex>
                            <Flex style={{marginBottom: '25px'}} column width='400px'>
                                <H3 marginBottom='5px'> E-post </H3>
                                <TextInput placeholder='E-post' label='E-post' value={this.props.email} disabled={true}/>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}

function mapStateToProps(state, props){
    const userId = UserSelector.getId(state);
    const employee = EmployeeSelector.getById(state, userId)
    var imageUrl = EmployeeSelector.getProfilePicture(employee);
    const name = EmployeeSelector.getEmployeeName(employee);
    const role = EmployeeSelector.getEmployeeRole(employee)
    const email = EmployeeSelector.getEmployeeEmail(employee)
    const isUploading = state.getIn(['employee', 'isUploading']);
    const displayName = EmployeeSelector.getDisplayName(employee);

    if(imageUrl.includes('/employee-avatar')){
        imageUrl = '';
    }

    //Access members through employee only?
    return {
        imageUrl: imageUrl,
        name: name,
        role: role,
        email: email,
        id: userId,
        isUploading: isUploading,
        displayName: displayName
    }
}
export default connect(mapStateToProps)(ProfilePicture);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/UserRoute/ProfilePicture/index.js